import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type UserIconProps = {
  size?: number
  color?: string
  className?: string
}

export const UserIcon = ({
  size = 16,
  color = tokenVar('colors.icon.secondary'),
  className,
}: UserIconProps) => (
  <svg
    aria-label='User'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.3333 14V12.6666C13.3333 11.9594 13.0523 11.2811 12.5522 10.781C12.0522 10.281 11.3738 10 10.6666 10H5.33327C4.62602 10 3.94774 10.281 3.44765 10.781C2.94755 11.2811 2.6666 11.9594 2.6666 12.6666V14M10.6666 4.66666C10.6666 6.13942 9.47272 7.33334 7.99994 7.33334C6.52718 7.33334 5.33327 6.13942 5.33327 4.66666C5.33327 3.1939 6.52718 2 7.99994 2C9.47272 2 10.6666 3.1939 10.6666 4.66666Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
)
